import 'firebase/firestore';
import firebase from 'firebase/app'




const firebaseConfig = {
  apiKey: "AIzaSyAhoD5LrcFsjQ1FyYhyiSUt4QLLvxeqWjg",
  authDomain: "uddibaba-c0763.firebaseapp.com",
  databaseURL: "https://uddibaba-c0763-default-rtdb.firebaseio.com",
  projectId: "uddibaba-c0763",
  storageBucket: "uddibaba-c0763.appspot.com",
  messagingSenderId: "728288965363",
  appId: "1:728288965363:web:eecd137081439225a3bd86",
  measurementId: "G-WRVKVW2FBQ"
  };

  firebase.initializeApp(firebaseConfig);

  export default firebase;
